var _path, _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.03125 17.5515L13.7382 9.40629C13.8915 9.26285 14.0997 9.19331 14.3084 9.21579L23.0557 10.1578C23.2508 10.1788 23.4461 10.1195 23.5965 9.99346L32.7064 2.36082M32.7064 2.36082L32.2734 6.40204M32.7064 2.36082L28.5208 2",
    stroke: "#FF6300",
    strokeWidth: 2.32935,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.03608,
    y: 24.4072,
    width: 5.70101,
    height: 12.5566,
    rx: 1.40721,
    fill: "#FF6300",
    stroke: "#FF6300",
    strokeWidth: 0.0721646
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.2724,
    y: 18.2734,
    width: 5.70101,
    height: 18.6906,
    rx: 1.40721,
    fill: "#FF6300",
    stroke: "#FF6300",
    strokeWidth: 0.0721646
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5107,
    y: 19.5722,
    width: 5.70101,
    height: 17.3917,
    rx: 1.40721,
    fill: "#FF6300",
    stroke: "#FF6300",
    strokeWidth: 0.0721646
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29.748,
    y: 16.1806,
    width: 5.70101,
    height: 20.7834,
    rx: 1.40721,
    fill: "#FF6300",
    stroke: "#FF6300",
    strokeWidth: 0.0721646
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.133cea103022e35b5eecfce7e5df8477.svg";
export { ForwardRef as ReactComponent };